import { ApplicationRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environments/environment';
import { browserTracingIntegration, init } from '@sentry/angular';
import { defaultStackParser } from '@sentry/browser';
import { AppModule } from '@app/app.module';
import { enableDebugTools } from '@angular/platform-browser';

if (environment.useSentry) {
  init({
    dsn: 'https://94aa0825c3d54ebcb73bff73e1865b85@o4504055350689793.ingest.sentry.io/4504055353442306',
    integrations: [
      browserTracingIntegration(),
    ],
    tracePropagationTargets: ['localhost', 'https://dev.pyjam.com/api'],
    stackParser: defaultStackParser,
    tracesSampleRate: 1.0,
  });
}

function notifyAppReady(): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new Event('pyjam:app-ready'));
  } catch {
    // no-op
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(ref => {
    notifyAppReady();
    if (!environment.production) {
      const applicationRef = ref.injector.get(ApplicationRef);
      const appComponent = applicationRef.components[0];
      enableDebugTools(appComponent);
    }
  })
  .catch(err => {
    notifyAppReady();
    console.log(err);
  });

// const paypalClientId = environment.paypal.clientId;

// if (paypalClientId != null) {
//   addPaypalCardFields(paypalClientId);
// }

// function addPaypalCardFields(paypalClientId: string) {
//   if (typeof document === 'undefined') return;
//   const scriptDiv = document.createElement('script');
//   scriptDiv.src = `https://www.paypal.com/sdk/js?intent=authorize&client-id=${paypalClientId}&debug=true&currency=EUR&components=buttons,card-fields`;
//   document.getElementsByTagName('head')[0].insertAdjacentElement('afterbegin', scriptDiv);
// }
